  <template>
    <div class="per-page-selection pull-right">
      Show
      <select name="select-per-age" @change="doVisible"  v-model="tablePerPage">
        <option v-for="amount in amountsShown" :value="amount.value">{{amount.text}}</option>
      </select>
      entries
    </div>  
  </template>

  <script>
  export default {
    props:['amountsShown', 'perPage'],
    data () {
      return {
        tablePerPage: this.perPage,
      }
    },
    methods: {
      doVisible () {
         this.$events.fire('per-page', this.tablePerPage)
       }
    }
  }
</script>